import React, {useEffect, useRef, useState} from "react"
import {NavLink, useNavigate, useParams} from "react-router-dom"

import "./Test.css"
import iconFolder from "../../assets/iconFolder.svg"

import TestNav from "../../component/Nav/TestNav"
import RightFooter from "../../component/Footer/RightFooter"
import TopHeader from "../../component/Nav/TopHeader"
import {getCode, getDateString, retrieveData, sendRequest} from "../../common";
import MyNav from "../../component/Nav/MyNav";
import ResultNav from "../../component/Nav/ResultNav";
import Footer from "../../component/Footer/Footer";
import iconCheck from "../../assets/inputCheck.svg"
import app from "../../App";
// import { Document, Page } from 'react-pdf';
import jsPDF from 'jspdf';
// import html2canvas from "html2canvas";
import { useReactToPrint } from 'react-to-print';
import TestResult from "./TestResult";

// import { PDFViewer, Document, Text, Page } from '@react-pdf/renderer';


function TestResults({}) {
	const {ids} = useParams()

	const testResult = useRef()

	const handlePrint = useReactToPrint({
		content: () => testResult.current,
		// fonts: [{family: 'Arial', source: 'sans-serif'}]
		// fonts: [{family: 'malgun gothic', source: `url("../../../assets/fonts/malgun.ttf") format("ttf")`}]
	});

	useEffect(() => {
		setTimeout(handlePrint, 5000 + ids?.length * 100)
	}, [])

	return (
		<div ref={testResult}>
			{ids?.split(',').map((id, index) => {
				return (
					<TestResult id={id}/>
				)
			})}
		</div>
	)
}

export default TestResults
